import { render, staticRenderFns } from "./StoreProdImg.vue?vue&type=template&id=70828cd2&scoped=true"
import script from "./StoreProdImg.vue?vue&type=script&lang=js"
export * from "./StoreProdImg.vue?vue&type=script&lang=js"
import style0 from "./StoreProdImg.vue?vue&type=style&index=0&id=70828cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70828cd2",
  null
  
)

export default component.exports